<app-infobox [pointData]="pointData" [penetration]="penetration"></app-infobox>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/value/transazioni-carta-indicator/transazioni-carta-indicator.component.html